// Import our CSS
import styles from '../css/app.pcss';
import icon from '../img/ImageOptimize-icon.svg';
